import {LobbyImage} from '@colonist/types'
import {createDivIn, createHeaderIn, createImgIn} from '../ui_utils/DomUtils.ts'
import {type EditProfileData, EditProfileTab, ViewPopupEditProfile} from './ViewPopupEditProfile.ts'
import {type TranslationObject} from '@colonist/i18n'

export class ViewPopupEditBotProfile extends ViewPopupEditProfile {
    constructor(editProfileData: EditProfileData) {
        const title: TranslationObject = {key: 'strings:homePage.popups.changeColor.title'}

        super(editProfileData, title)

        this.toggleContainer.classList.add('hidden')
        this.colorSelectorContainer.classList.add('small-popup')

        this.setTab(EditProfileTab.Color)
    }

    protected createUsernameEditor(username?: string) {
        const userInformationContainer = createDivIn(this.body, 'edit-profile-user-information-container no-edit')
        const iconUsernameContainer = createDivIn(userInformationContainer, 'edit-profile-icon-username-container')
        createImgIn(iconUsernameContainer, LobbyImage.Bot, 'edit-profile-user-icon')
        createHeaderIn(iconUsernameContainer, {key: 'strings:colonistCommon.utils.#buffer', options: {value: username}}, 'edit-profile-username', undefined, 'H2')
    }
}
